import { render, staticRenderFns } from "./DeclinedPayments.vue?vue&type=template&id=eb1ac3d8"
import script from "./DeclinedPayments.vue?vue&type=script&lang=js"
export * from "./DeclinedPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports